/* eslint-disable no-unused-vars */
import { useEffect, useRef, useState } from 'react';
import { RiMapPin2Fill } from 'react-icons/ri';

function loadGoogleMapsScript() {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
        }

        const script = document.createElement('script');
        script.src = `${process.env.REACT_APP_GOOGLE_MAP_API_JS}?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places,marker&callback=initMap`;
        script.async = true;
        script.defer = true;

        window.initMap = () => {
            resolve(window.google.maps);
        };

        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function GoogleMapNew({ className, onChange, defaultValue = {} }) {
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(defaultValue);

    useEffect(() => {
        const initMap = async () => {
            try {
                const googleMaps = await loadGoogleMapsScript();

                if (mapRef.current && !map) {
                    const defaultCenter = {
                        lat: parseFloat(defaultValue.lat) || 25.761681,
                        lng: parseFloat(defaultValue.lng) || -80.191788,
                    };

            const mapInstance = new googleMaps.Map(mapRef.current, {
                center: defaultCenter,
                zoom: 13,
                disableDefaultUI: true,
                zoomControl: true,
          });

              const marker = new googleMaps.Marker({
                  position: defaultCenter,
                  map: mapInstance,
                  icon: {
                      url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                      scaledSize: new googleMaps.Size(40, 40),
                      origin: new googleMaps.Point(0, 0),
                      anchor: new googleMaps.Point(20, 40),
                  },
              });

            setMap(mapInstance);
            setCurrentLocation(defaultCenter);

            mapInstance.addListener('click', (e) => {
                const newLocation = {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                };
                marker.setPosition(newLocation);
                setCurrentLocation(newLocation);
                if (onChange) onChange(newLocation);
            });
        }
            } catch (error) {
                console.error('Error loading Google Maps:', error);
            }
        };

      initMap();
    }, [defaultValue, onChange]);

    return (
        <div className={className}>
            <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
        </div>
    );
}

export default GoogleMapNew;
